'use client';

import { Header, Link } from '@/payload-types';
import { clsx } from 'clsx';
import { CMSLink } from '@/components/Link';
import { ChevronDown } from 'lucide-react';
import { useRef, useState } from 'react';
import { useClickOutside } from '@/hooks/useClickOutside';
import { WithSublinks } from '@/types/WithSublinks';

interface IDHeaderItemProps {
  item: {
    id?: string | null
    link: Link & WithSublinks
  };
}

export default function DHeaderItem(props: IDHeaderItemProps) {
  const { item } = props;

  const [isExpanded, setIsExpanded] = useState(false);

  const toggleDropdown = () => setIsExpanded(!isExpanded);

  const ref = useRef<HTMLDivElement>(null);
  useClickOutside(ref, outside => {
    if (outside) setIsExpanded(false);
  });

  return (
    <div ref={ref}>
      <div className="flex items-center">
        <CMSLink {...item.link} className="py-4 text-nowrap" />
        {Boolean(item.link.sublink?.length) && (
          <button
            onClick={toggleDropdown}
            aria-label='Toggle drop down'
          >
            <ChevronDown
              height={16}
              className={clsx(
                'transition-all duration-500 group-hover:-rotate-180',
                isExpanded && '-rotate-180',
              )}
            />
          </button>
        )}
      </div>
      {Boolean(item.link.sublink?.length) && (
        <div
          className={clsx(
            'absolute delay-100 -left-2 whitespace-nowrap overflow-hidden min-w-full transition-all duration-500 max-h-0 group-hover:max-h-96 shadow rounded-lg',
            isExpanded && 'max-h-96',
          )}
        >
          <ul className="text-black bg-white border border-neutral-200 rounded-lg p-3">
            {item.link.sublink?.map((sublink, index) => (
              <li key={`${item.id}_${index}`}>
                <CMSLink
                  {...sublink}
                  className={clsx(
                    'font-medium not-last-of-type:mb-2 py-1',
                    'block w-full delay-100 transition-all duration-500 -translate-y-2 group-hover:translate-y-0',
                    'hover:text-secondary-500 hover:delay-75',
                    isExpanded && 'translate-y-0',
                  )}
                />
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
